export default {
  "lang.label": "语言",
  "lang.zh-TW": "繁中",
  "lang.zh-CN": "简中",
  "lang.en": "英文",
  "lang.ja": "日文",
  "nav.home": "首页",
  "nav.about": "品牌介绍",
  "nav.books": "书籍资料库",
  "nav.stores": "合作渠道",
  "nav.faq": "常见问题",
  "nav.blog": "编辑选书",
  "nav.contact": "联络我们",
  "nav.partners": "合作伙伴",
  "nav.services": "服务内容",
  "nav.app": "爽读 App",
  "nav.more": "更多",
};
